import { makeStyles, Theme, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { CSS_COLOR_VARS } from "constants/colors";

export const ToolTipInfoIcon = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: "rgba(235, 174, 35, 0.8)",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 200,
    boxShadow: "1px 1px 1px 1px #ccc",
    padding: 7,
    borderRadius: 10,
  },
}))(Tooltip);

export const usePopoverStyle = makeStyles({
  root: {
    flexGrow: 1,
  },
  divWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
  },
  widthIcon: {
    width: "20px",
  },
  ToolTipIconTitle: {
    fontWeight: "bold",
    fontSize: 13,
  },
  toolTipIconMessage: {
    fontWeight: "lighter",
    fontSize: 10,
  },
  by: {
    fontWeight: "bold",
    fontSize: 10,
  },
  at: {
    fontWeight: "bold",
    fontSize: 10,
  },
  infoIcon: {
    color: CSS_COLOR_VARS.primary,
    marginLeft: 10,
  },
  btnIcon: {
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
});
